export enum Brand {
  GRUBHUB = 'grubhub',
  SEAMLESS = 'seamless',
}
